import React from 'react';
import TabelaCadastroEdicaoPrecosMensalidades from '../tabela-cadastro-edicao-precos-mensalidades';
import './cadastro-edicao-precos-mensalidade-lote.css';

export default function CadastroEdicaoPrecosMensalidadeLote() {
    return (
        <div className="page-cadastro-edicao-precos-lote">
            <TabelaCadastroEdicaoPrecosMensalidades />
        </div>
    );
}